module.exports = __webpack_public_path__ + "static/media/RecordValidationSVG.0fa45412.svg";